import { useEffect, useState } from "react"
import { getFormatFecha } from "../../helpers/dates"
import PageController from "../pageController/PageController"
import './tbStyles.css'

export const TbVotes = ({ votes, deleteVote }) => {

  const [votos, setVotos] = useState([])
  const [initData, setInitData] = useState(0)
  const pagesize = parseInt(process.env.REACT_APP_PAGE_RECORDS);

  useEffect(() => {
    const loadData = async () => {
      setVotos(await votes.slice(initData, initData + pagesize));
    }
    loadData()
  }, [votes, initData, pagesize]);

  return (
    <div className="table-container">
      <table cellSpacing='0'>
        <thead>
          <tr>
            <th>PUEBLO</th>
            <th className="responsive">FECHA</th>
            <th>CANCION</th>
            <th className="responsive-movil">IP</th>
            <th className="responsive">FECHOR</th>
            <th >ACCIONES</th>
          </tr>
        </thead>
        <tbody>
          {Array.isArray(votos)
            ? votos.map((voto, index) => (
              <tr key={index}>
                <td >{voto.PUE_NOMBRE}</td>
                <td className="responsive">{getFormatFecha(voto.PUE_FECACT)}</td>
                <td>{voto.CAN_TITULO}</td>
                <td className="responsive-movil">{voto.VOT_DIRIP}</td>
                <td className="responsive">{getFormatFecha(voto.VOT_FECHOR)}</td>
                <td><button
                  onClick={() => deleteVote({
                    'idVillage': voto.PUE_CLAVE,
                    'idSong': voto.CAN_CLAVE,
                    'dirip': voto.VOT_DIRIP
                  })}
                  className="material-icons-outlined">delete</button></td>
              </tr>
            ))
            : <h1>NO HAY DATOS EN LA TABLA</h1>}
        </tbody>
      </table>
      <section className="tbFooter">
        <PageController initData={initData} setInitData={setInitData} length={votes.length} />
      </section>
    </div>
  )
}
